// extracted by mini-css-extract-plugin
module.exports = {"ad":"story-footer-module__ad__1Rbe-","metype":"story-footer-module__metype__IcWl9"};